import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router";

export default function Searchengine() {
  const navigate = useNavigate();
  const [searchelement, setsearchelement] = useState("");

  function fetchDatas(path) {
    const apiUrl = `https://api.shecodes.io/dictionary/v1/define?word=${searchelement}&key=tfc5b1174a6eb0eo33d062c2b145a43f`;
    const ImageApiUrl = `https://api.shecodes.io/images/v1/search?query=${searchelement}&key=tfc5b1174a6eb0eo33d062c2b145a43f`;

    axios
      .all([axios.get(apiUrl), axios.get(ImageApiUrl)])
      .then(
        axios.spread((DictResponse, ImageResponse) => {
          const ImageUrl = ImageResponse.data.photos[0]?.src?.landscape;
          navigate(path, {
            state: { resultData: DictResponse.data, ImageUrl: ImageUrl },
          });
        })
      )
      .catch((error) => {
        alert("Please check your word");
      });
  }

  function submit1(event) {
    event.preventDefault();
    fetchDatas("/results");
  }
  function submit2(event) {
    event.preventDefault();
    fetchDatas("/synonyms");
  }

  function loadinput(event) {
    event.preventDefault();
    setsearchelement(event.target.value);
  }

  return (
    <div className="">
      <form className="formsearch" onSubmit={submit1}>
        <input
          className="form-control mb-4"
          placeholder="Search"
          onChange={loadinput}
        ></input>
        <button className="btn btn-info rounded-circle me-5 p-3" type="submit">
          Get Definition
        </button>
        <button
          className="btn btn-warning btn-box-shadow rounded-circle ms-5 p-3"
          type="button"
          onClick={submit2}
        >
          Get Synonyms
        </button>
      </form>
    </div>
  );
}
